// extracted by mini-css-extract-plugin
export var circle = "_m-2";
export var icon = "_m-a";
export var iconHighlight = "_m-0";
export var lg = "_m-8";
export var md = "_m-7";
export var outline = "_m-4";
export var sm = "_m-6";
export var square = "_m-1";
export var xl = "_m-9";
export var xs = "_m-5";
export var xxs = "_m-3";